import styled from '@emotion/styled'
import type {
  DraggableProvided,
  DraggableStateSnapshot,
  DroppableProvided,
  DroppableStateSnapshot,
} from '@hello-pangea/dnd'
import { Draggable, Droppable } from '@hello-pangea/dnd'
import { Component, ReactElement } from 'react'

import { MercurySimpleProductFragment, ProductFragment } from '@/graphql'

import FacingItem from './Facing'

interface WrapperProps {
  isDraggingOver: boolean
}

const Wrapper = styled.div<WrapperProps>`
  flex: 1;
  display: flex;
`

const DropZone = styled.div`
  flex: 1;
  display: flex;

  flex-direction: row;
  overflow-x: scroll;
  scrollbar-width: none;
  min-height: 60px;

  /* Add these properties to constrain width */
  width: 0; /* Forces the element to not grow beyond parent */
  min-width: 0; /* Allows the element to shrink below its content size */
`

interface Props {
  facings: {
    id: string
    product: ProductFragment | MercurySimpleProductFragment
  }[]
  listId: string
  isDropDisabled?: boolean
  selectedIndices?: number[]
  onFacingClick?: (shelfIndex: number, columnIndex: number) => void
  onFacingDoubleClick?: (shelfIndex: number, columnIndex: number) => void
  onFacingMouseDown?: () => void
  alwaysShowDropShadow?: boolean
}

export default class Shelf extends Component<Props> {
  renderBoard = (dropProvided: DroppableProvided): ReactElement => {
    const { facings, listId, onFacingMouseDown, alwaysShowDropShadow } =
      this.props

    return (
      <DropZone ref={dropProvided.innerRef}>
        {facings.map(
          (
            facing: {
              id: string
              product: ProductFragment | MercurySimpleProductFragment
            },
            index: number,
          ) => (
            <Draggable
              key={facing.id + index}
              draggableId={`${facing.product.upcA}-${listId}-${index}`} // THIS MIGHT BE CAUSING AN ISSUE BUT IT FIXES THE WEIRD SCROLL TO BOTTOM OF LIST
              index={index}
            >
              {(
                dragProvided: DraggableProvided,
                dragSnapshot: DraggableStateSnapshot,
              ) => (
                <FacingItem
                  onClick={() =>
                    this.props.onFacingClick?.(Number(this.props.listId), index)
                  }
                  onDoubleClick={() =>
                    this.props.onFacingDoubleClick?.(
                      Number(this.props.listId),
                      index,
                    )
                  }
                  onMouseDown={onFacingMouseDown}
                  facing={facing}
                  provided={dragProvided}
                  snapshot={dragSnapshot}
                  alwaysShowDropShadow={alwaysShowDropShadow}
                  selected={this.props.selectedIndices?.includes(index)}
                />
              )}
            </Draggable>
          ),
        )}
        {dropProvided.placeholder}
      </DropZone>
    )
  }

  render(): ReactElement {
    const { listId, isDropDisabled } = this.props

    return (
      <Droppable
        droppableId={listId}
        type={'CARD'}
        direction="horizontal"
        isDropDisabled={isDropDisabled}
      >
        {(
          dropProvided: DroppableProvided,
          dropSnapshot: DroppableStateSnapshot,
        ) => (
          <Wrapper
            isDraggingOver={dropSnapshot.isDraggingOver}
            {...dropProvided.droppableProps}
          >
            {this.renderBoard(dropProvided)}
          </Wrapper>
        )}
      </Droppable>
    )
  }
}
